var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Dropdown as BootstrapDropdown } from "react-bootstrap";
import id from "@irati/utils/id";
import { DropdownMenu, StyledButtonToolbar, StyledHr, ToggleButton } from "./styled/Dropdown";
var Dropdown = /** @class */ (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            open: false
        };
        _this.toggle = function () {
            var disabled = _this.props.disabled;
            if (!disabled)
                _this.setState({ open: !_this.state.open });
        };
        _this.close = function () { return _this.setState({ open: false }); };
        return _this;
    }
    Dropdown.prototype.render = function () {
        var _a = this.props, pullRight = _a.pullRight, header = _a.header, footer = _a.footer, children = _a.children, iconColor = _a.iconColor, icon = _a.icon;
        var idNamespace = id("dropdown", this.props);
        var open = this.state.open;
        return (React.createElement(StyledButtonToolbar, null,
            React.createElement(BootstrapDropdown, { id: idNamespace, open: open, onToggle: this.toggle, pullRight: pullRight, componentClass: "div" },
                React.createElement(ToggleButton, { slim: true, bsRole: "toggle", icon: icon, testing: "true", color: iconColor }),
                React.createElement(DropdownMenu, { bsRole: "menu", onClick: this.close },
                    header && (React.createElement(React.Fragment, null,
                        " ",
                        header,
                        " ",
                        React.createElement(StyledHr, null),
                        " ")),
                    children,
                    footer && (React.createElement(React.Fragment, null,
                        " ",
                        React.createElement(StyledHr, null),
                        " ",
                        footer,
                        " "))))));
    };
    Dropdown.defaultProps = {
        pullRight: false,
        header: null,
        footer: null,
        iconColor: null,
        icon: "filter",
        disabled: false
    };
    return Dropdown;
}(PureComponent));
export default Dropdown;
